import React from 'react';
import axios from 'axios';
import { HiringCompanies } from '../components/local';

import {
  Hero,
  CardA,
  CardB,
  HowItWorks,
  CandidateRoles,
  WhyAlmaBetter,
  RecruiterTestimonials,
  StudentTestimonials,
} from '../components/local/hire-from-us';

import PressHighlights from '../components/shared/PressHighlights';

import { getStrapiURL } from '../lib/api';
const apiBaseUrl = getStrapiURL();

import SiteHeader from '../components/shared/SiteHeader';

const HireFromUs = ({ pressHighlights, hiringPartnersList, hireData }) => {
  return (
    <>
      <SiteHeader
        title={hireData?.seo?.MetaTitle}
        desc={hireData?.seo?.MetaDescription}
        url={hireData?.seo?.MetaUrl}
        image={hireData?.seo?.image?.data?.attributes?.url}
      />
      <div id="modal">
        <Hero />

        <HiringCompanies
          newHiring
          hiringPartners={hiringPartnersList}
          heading={'Top Companies are hiring from'}
          highlightedText={'AlmaBetter'}
        />

        <CandidateRoles />

        <HowItWorks />

        <WhyAlmaBetter />

        <RecruiterTestimonials />

        <StudentTestimonials />

        {/* <CardA imgLink="/assets/images/hire-from-us/Group 1000002260@2x 1@3x.png">
          <h2 className="my-4 text-center lg:text-left">Access top notch Tech Talent</h2>
          <p className="text-body my-2 text-center leading-8 lg:my-4 lg:text-left">
            Our students are trained in our flagship full-stack Data Science program and would be
            top fit for a multitude of data-oriented roles.
          </p>
          <a
            href="#hire-form"
            className="btn-sm-explore text-md mx-auto mt-4 mr-auto flex w-fit rounded-sm bg-red px-12 py-2 font-satoshi-medium font-medium  uppercase text-white md:text-lg"
          >
            Hire Now
          </a>
        </CardA>
        <CardB imgLink="/assets/images/hire-from-us/hire from us metrics-min.png">
          <h2 className="text-center lg:m-4 lg:text-left">Intensive Candidate Training</h2>
          <p className="text-body my-2 text-center leading-8 lg:m-4 lg:w-3/4 lg:text-left">
            Our training process is quite intensive simulating a workplace environment for students
            to work in teams to solve industry relevant projects. With prior hands-on experience,
            our candidates are productive from Day 1 at the job.
          </p>
        </CardB>
        <CardA imgLink="/assets/images/hire-from-us/Group 1000002203@3x.png">
          <h2 className="my-2 text-center lg:m-4 lg:text-left">
            Pre-Evaluation by Industry Professionals
          </h2>
          <p className="text-body my-2 text-center leading-8 lg:m-4 lg:text-left">
            All AlmaBetter graduates eligible for hiring are pre-screened by top industry
            professionals working at Fortune 500 companies. We also provide detailed student
            performance report to the recruiters for verification purposes
          </p>
        </CardA>
        <PressHighlights showFeatured pressHighlights={pressHighlights} showSeeMore={true} /> */}
      </div>
    </>
  );
};

export default HireFromUs;

export async function getStaticProps(context) {
  try {
    const { data: pressHighlights } = await axios.get(
      `${apiBaseUrl}/api/press-hightlight?populate=highlights.image`
    );
    const { data: hiringPartners } = await axios.get(
      `${apiBaseUrl}/api/hiring-partner?populate=partners.images`
    );
    const { data: hire } = await axios.get(`${apiBaseUrl}/api/hire?populate=seo.image`);

    // const { data: testimonials } = await axios.get(`${apiBaseUrl}/api/hire-testimonials`);
    return {
      props: {
        pressHighlights: pressHighlights.data || {},
        hiringPartnersList: hiringPartners.data.attributes.partners || [],
        hireData: hire.data.attributes,
        // testimonials: testimonials.data,
      },
      revalidate: 3600,
    };
  } catch (error) {
    return { props: { error: error.message } };
  }
}

// //!  NEW hire form us make SSG from SSR
// import axios from 'axios';
// import HireForm from '@shared/forms/HireForm';

// import {
//   Hero,
//   CardA,
//   HireTestimonials,
//   Testimonials,
//   HireMetrics,
//   WhyHireFromUs,
//   HireFormFaq,
//   HiringPartners,
// } from '@local/hire-from-us';

// import PressHighlights from '@shared/PressHighlights';

// import { getStrapiURL } from '@lib/api';
// const apiBaseUrl = getStrapiURL();

// import SiteHeader from '@shared/SiteHeader';
// import { HowAlmabetterWorks } from '@local/card/HowAlmaWorksCard';

// const HireFromUs = ({
//   pressHighlights,
//   hiringPartnersList,
//   hireData,
//   howABWorks,
//   hireTestimonials,
//   testimonials,
// }) => {
//   const { hero, metrics, whyHireFromUs, hireSection, hireFaq } = hireData;
//   const hiringPartner = {
//     heading:
//       'Trusted by top tech startups and fortune companies to build highly efficient data & engineering teams',
//   };
//   return (
//     <>
//       <SiteHeader
//         title={hireData?.seo?.MetaTitle}
//         desc={hireData?.seo?.MetaDescription}
//         url={hireData?.seo?.MetaUrl}
//         image={hireData?.seo?.image?.data?.attributes?.url}
//       />
//       <section className="mx-auto w-11/12 lg:w-10/12 [&>*:not(:first-child)]:mt-20">
//         <Hero hero={hero} />

//         <Testimonials testimonials={testimonials} />

//         <HireMetrics metrics={metrics.metrics} />

//         <HiringPartners
//           data={hiringPartner}
//           hiringPartnersList={hiringPartnersList}
//           bgColor="white"
//         />

//         <WhyHireFromUs data={whyHireFromUs} />

//         <CardA imgLink={hireSection.heroImage.data.attributes.url}>
//           <h2 className="my-4 text-center lg:text-left">{hireSection.heading}</h2>
//           <p className="my-2 text-base leading-6 text-center text-gray-dark md:leading-8 lg:text-left">
//             {hireSection.description}
//           </p>
//           <a
//             href="#hire-form"
//             className="flex px-12 py-2 mx-auto mt-4 mr-auto font-satoshi-medium font-medium  text-white rounded-sm btn-sm-explore text-md w-fit bg-red md:text-lg"
//           >
//             Hire Now
//           </a>
//         </CardA>

//         <HowAlmabetterWorks />
//         {hireTestimonials?.length > 0 && <HireTestimonials testimonials={hireTestimonials} />}

//         <PressHighlights pressHighlights={pressHighlights} showSeeMore={true} />

//         <HireForm />
//         <HireFormFaq data={hireFaq} />
//       </section>
//     </>
//   );
// };

// export default HireFromUs;

// export async function getServerSideProps(context) {
//   try {
//     const { data: pressHighlights } = await axios.get(
//       `${apiBaseUrl}/api/press-hightlight?populate=highlights.image`
//     );
//     const { data: hiringPartners } = await axios.get(
//       `${apiBaseUrl}/api/hiring-partner?populate=partners.images&filter[companyType][$eq]=finTech`
//     );

//     const { data: hireTestimonials } = await axios.get(
//       `${apiBaseUrl}/api/hire-testimonials?populate=companyLogo&populate=image`
//     );
//     const { data: howABWorks } = await axios.get(
//       `https://strapi.almagrow.com/api/homepage?populate=HowAlmaWorks.almaSteps.icon`
//     );
//     const { data: hire } = await axios.get(
//       `${apiBaseUrl}/api/hire?populate=hero&populate=metrics.metrics.icon&populate=whyHireFromUs.metrics.icon&populate=hireSection.heroImage&populate=seo.image&populate=hireFaq.faq`
//     );

//     const { data: testimonials } = await axios.get(
//       `${apiBaseUrl}/api/testimonials?populate=companyLogo&populate=avatar`
//     );
//     return {
//       props: {
//         pressHighlights: pressHighlights.data || {},
//         hiringPartnersList: hiringPartners.data.attributes.partners || [],
//         hireData: hire.data.attributes,
//         howABWorks,
//         hireTestimonials: hireTestimonials.data,
//         testimonials: testimonials.data,
//       },
//     };
//   } catch (error) {
//     return { props: { error: error.message } };
//   }
// }
